<template>
  <q-form @submit="this.onSubmit" class="ms-form ms-form--narrow">
    <div class="ms-form-grid ms-form-grid--single">
      <CustomSelect
        :options="this.specialities"
        label="Специализация"
        optionValueKey="speciality_id"
        optionLabelKey="speciality_name"
        :value="this.formData.speciality_id || ''"
        @change="(value) => onChange('speciality_id', value)"
      />
    </div>
    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import {appActionTypes} from "@/services/store/modules/app_module/app_mutation_types";

export default {
  name: "edit-handbook-workset-speciality",
  components: {CustomSelect, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        speciality_id: this.data?.body?.speciality_id || '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
  computed: {
    specialities() {
      return this.$store.state.app.specialities;
    },
  },
  mounted() {
    this.$store.dispatch(appActionTypes.getSpecialities)
  }
}
</script>
